import { getPagingInfo, } from '@dossierhq/core';
import isEqual from 'lodash/isEqual.js';
const DEFAULT_VALUES = {
    reverse: true,
    requestedCount: 25,
};
export function initializeChangelogState({ actions, }) {
    let state = {
        query: {},
        paging: {},
        requestedCount: DEFAULT_VALUES.requestedCount,
        connection: undefined,
        connectionError: undefined,
        totalCount: null,
        edges: null,
        loadingState: '',
        scrollToTopSignal: 0,
    };
    // Normalize query state
    state = reduceChangelogState(state, new SetQueryAction({}, { partial: true, resetPagingIfModifying: false }));
    if (actions) {
        for (const action of actions) {
            state = reduceChangelogState(state, action);
        }
    }
    return state;
}
export function reduceChangelogState(state, action) {
    const newState = action.reduce(state);
    // if (state !== newState) console.log(`State changed for ${action.constructor.name}`, state, action, newState);
    return newState;
}
class SetPagingAction {
    paging;
    pagingCause;
    constructor(paging, pagingCause) {
        this.paging = paging;
        this.pagingCause = pagingCause;
    }
    reduce(state) {
        if (isEqual(this.paging, state.paging)) {
            return state;
        }
        const { count } = getPagingInfo(this.paging).valueOrThrow();
        return {
            ...state,
            paging: this.paging,
            requestedCount: count || state.requestedCount,
            loadingState: this.pagingCause ?? '',
        };
    }
}
class SetQueryAction {
    value;
    partial;
    resetPagingIfModifying;
    constructor(value, { partial, resetPagingIfModifying }) {
        this.value = value;
        this.partial = partial;
        this.resetPagingIfModifying = resetPagingIfModifying;
    }
    reduce(state) {
        const query = this.partial
            ? { ...state.query, ...this.value }
            : { ...this.value };
        if (query.reverse === undefined)
            query.reverse = DEFAULT_VALUES.reverse;
        if (isEqual(query, state.query)) {
            return state;
        }
        let { paging, loadingState } = state;
        if (this.resetPagingIfModifying) {
            paging = {};
            loadingState = 'first-page';
        }
        return { ...state, query, paging, loadingState };
    }
}
class UpdateSearchResultAction {
    connection;
    connectionError;
    constructor(connection, connectionError) {
        this.connection = connection;
        this.connectionError = connectionError;
    }
    reduce(state) {
        if (state.connection === this.connection && state.connectionError === this.connectionError) {
            return state;
        }
        let { edges, scrollToTopSignal, loadingState } = state;
        if (this.connection !== undefined) {
            edges = this.connection === null ? [] : this.connection.edges;
            if (['first-page', 'prev-page', 'next-page', 'last-page'].includes(loadingState)) {
                scrollToTopSignal += 1;
                loadingState = '';
            }
        }
        return {
            ...state,
            connection: this.connection,
            connectionError: this.connectionError,
            edges,
            scrollToTopSignal,
            loadingState,
        };
    }
}
class UpdateTotalCountAction {
    totalCount;
    constructor(totalCount) {
        this.totalCount = totalCount;
    }
    reduce(state) {
        if (state.totalCount === this.totalCount) {
            return state;
        }
        return {
            ...state,
            totalCount: this.totalCount,
        };
    }
}
export const ChangelogStateActions = {
    SetPaging: SetPagingAction,
    SetQuery: SetQueryAction,
    UpdateSearchResult: UpdateSearchResultAction,
    UpdateTotalCount: UpdateTotalCountAction,
};
export function getQueryWithoutDefaults(query) {
    let changed = false;
    const newQuery = { ...query };
    if (query.reverse === DEFAULT_VALUES.reverse) {
        delete newQuery.reverse;
        changed = true;
    }
    return changed ? newQuery : query;
}
//# sourceMappingURL=ChangelogReducer.js.map